import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from "react-router-dom";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { BalloonGame } from '@genomawork/genoma-games-old';
import Tour from 'reactour';
import 'antd/dist/antd.css';
import '../App.css';
import { SERVER_URL } from '../AppRouter'

import { Button } from 'antd';

// Tour copy per language, keyed the same way `lang` arrives in the query string.
const tourTranslations: Record<string, { readyTitle: string; readyBodyPrefix: string; playButtonLabel: string; readyBodySuffix: string }> = {
  es: {
    readyTitle: '¿Estás listo/a para jugar?',
    readyBodyPrefix: 'Una vez que presiones el botón',
    playButtonLabel: 'Jugar',
    readyBodySuffix: ', comenzará la fase de medición y tus resultados serán considerados en tu evaluación.',
  },
  pt: {
    readyTitle: 'Você está pronto/a para jogar?',
    readyBodyPrefix: 'Assim que você pressionar o botão',
    playButtonLabel: 'Jogar',
    readyBodySuffix: ', a fase de avaliação começará e seus resultados serão considerados na sua avaliação.',
  },
};

// Tour config sin testGame
const customTourConfig = (playTestGame: any, playMeasurementGame: any, language: string = 'es') => {
  const t = tourTranslations[language] || tourTranslations.es;

  return [
  // {
    // selector: '[data-tut="reactour__steps"]',  
    // content: (<>En este juego te serán presentados 5 globos, uno por cada etapa.</>),
    // highlightTargets: ['[data-tut="reactour__steps"]']  
    // },
    // {
    // selector: '[data-tut="reactour__blow-up"]',  
    // content: (<>Para cada globo deberás presionar el botón <strong style={{ color: '#F175A5', fontWeight: 'bold' }}>Inflar</strong> para incrementar su tamaño y de esta forma acumularás dinero en una cuenta temporal por cada etapa.</>),
    // highlightTargets: ['[data-tut="reactour__blow-up"]']  
    // },
    // {
    //   selector: '[data-tut="reactour__accumulate"]',
    //   content: (<>En cualquier momento puedes parar de inflar el globo y presionar el botón <strong style={{ color: '#77c601', fontWeight: 'bold' }}>Recolectar</strong> para que el dinero temporal que has juntado pase a una cuenta permanente. </>),
    // },
    // {
    //   selector: '[data-tut="reactour__possible-accumulated-coins"]',
    //   content: (<>Esta es la cuenta temporal por cada inflada. </>),
    // },
    // {
    //   selector: '[data-tut="reactour__accumulated-coins"], [data-tut="reactour__accumulate"]',
    //   content: (<>Aquí verás la cuenta permanente del dinero que irás acumulando cada vez que presiones <strong style={{ color: '#77c601', fontWeight: 'bold' }}>Recolectar</strong>.</>),
    // },
    // {
    //   selector: '[data-tut="reactour__balloon"]',
    //   content: (<>Es tu decisión determinar cuánto inflar cada globo, pero ten en cuenta que los globos pueden explotar en cualquier momento. </>),
    // },
    // {
    //   selector: '[data-tut="reactour__balloon"]',
    //   content: (<>Si un globo explota antes de que pulses <strong>Recolectar</strong>, perderás todo el dinero que habías juntado temporalmente en esa etapa. </>),
    // },
    // {
    //   // selector: '[data-tut="reactour__balloon"]',
    //   content: (<>Este juego no tiene tiempo, por lo que no es necesario que te apresures.</>),
    // },
    {
    selector: '[data-tut="reactour__play"]',
    content: function DemoHelperComponent() {
      return (
        <div>
          <p>
            <strong style={{ color: '#F175A5', fontSize: '17px' }}>
              {t.readyTitle}
            </strong>
            <br /><br />
            {t.readyBodyPrefix}{' '}
            <strong style={{ color: '#F175A5' }}>{t.playButtonLabel}</strong>
            {t.readyBodySuffix}
          </p>
          <div style={{ color: '#F175A5', display: 'flex', justifyContent: 'center' }}>
            <Button onClick={playMeasurementGame}>
              {t.playButtonLabel}
            </Button>
          </div>
        </div>
      );
    }
  }
  ];
};

function BalloonGameDemo() {
  const [showGame, setShowGame] = useState(false)
  const queryString = new URLSearchParams(window.location.search);

  const navigate = useNavigate();
  const token = queryString.get("token") || null
  const callback = queryString.get("callback") || null;
  const language = queryString.get("lang") || 'es';

  useEffect(() => {
    if (!token){
      navigate("/notFound");
    }
    axios({
      method: 'get',
      url: `${SERVER_URL}?path=demo&token=${token}`,
      withCredentials: false,
    }).then((response) => {
      if (response.status < 400){
        if (response.data['newRoute'] === 'feedback'){
          setShowGame(false);
          if (callback) {
            window.location.href = callback + `?token=${token}&lang=${language}`;
            return; // Ensure the function exits after redirecting
          }
          navigate(`/feedback?token=${token}`);
        } else {
          setShowGame(true);
        }
      }
    }).catch((error) => {
      navigate("/notFound");
    })
  }, [])

  async function postData (allData: any) {
    const submit = `{"game_outcome":${JSON.stringify(allData)}}`;
    const url = `${SERVER_URL}?path=demo&token=${token}`;

    return axios({
      method: 'post',
      url: url,
      withCredentials: false,
      data: submit,
      headers: {
        'Content-Type': 'application/json'
      }
    }).then((response) => {
      if (response.status < 400){
          setShowGame(false);
          if (callback) {
            window.location.href = callback + `?token=${token}&lang=${language}`;
            return; // Ensure the function exits after
          }
          navigate(`/feedback?${queryString}`);
      } else {
        setShowGame(true);
      }
      })
};

  return (
      <div className="protected full-height ant _global_gamesLayout__kXOKp">
        {showGame && 
        <BalloonGame
          tour={Tour}
          maxSteps={5}
          dilemma={true}
          callbackStart={() => {
            return new Promise((resolve) => {
              console.log("Starting game...");
              setTimeout(() => resolve("OK"), 500);
            });
          }}
          callback={postData}
          language={language}
          tourConfig={(playTestGame: any, playMeasurementGame: any) => customTourConfig(playTestGame, playMeasurementGame, language)}
          unloadAlert={false}
        />}
      </div>
  );
}

export default BalloonGameDemo;
